import React from "react";
export function SkeletonLastLoginCard() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid gap-6 bg-white rounded-2xl p-6 shadow-md animate-pulse"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-6 w-32 rounded bg-slate-200"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-10 w-3/4 rounded bg-slate-200"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "h-6 w-20 rounded bg-slate-200"
    }));
}
export default function SkeletonUserActivityTopCards() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-2 gap-10"
    }, [0, 1].map(col => /*#__PURE__*/ React.createElement("div", {
        key: col
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-6 h-10 w-48 rounded bg-slate-200 animate-pulse"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col gap-6"
    }, [0, 1, 2].map(i => /*#__PURE__*/ React.createElement(SkeletonLastLoginCard, {
        key: i
    }))))));
}
